import { useState, useEffect } from 'react';
import useBackendApi from './useBackendApi';
import { AUTHENTICATED } from '../constants/user';

const useNotificationCount = (isUserDataReady, userType, setErrorMessage) => {
  const [notificationCount, setNotificationCount] = useState(null);
  const { apiFetchRequest } = useBackendApi();

  useEffect(() => {
    const fetchNotificationCount = async () => {
      if (!isUserDataReady || userType !== AUTHENTICATED) {
        return;
      }

      try {
        const res = await apiFetchRequest({
          endpoint: '/api/messages/get_unread_count',
          method: 'GET',
        });

        if (res?.status === 200) {
          setNotificationCount(res.body.count);
        } else {
          setErrorMessage('Failed to fetch notification count.');
        }
      } catch (error) {
        console.error('Failed to fetch notification count', error);
        setErrorMessage('Failed to fetch notification count.');
      }
    };

    fetchNotificationCount();
  }, [isUserDataReady, userType, apiFetchRequest, setErrorMessage]);

  return { notificationCount };
};

export default useNotificationCount;
